/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from "react";

/**
 * Splits a string and inserts <wbr> hints after each delimiter occurrence so
 * the browser can wrap at logical boundaries rather than mid-word.
 *
 * @param text - The string to render (e.g. an email address).
 * @param delimiters - Characters to insert break hints after (default: '@' and '.').
 */
export const renderWithWordBreaks = (text: string, delimiters = ["@", "."]) => {
  const escaped = delimiters.map((d) => "\\" + d).join("|");
  const pattern = new RegExp(`(${escaped})`);
  let offset = 0;
  return text.split(pattern).map((part) => {
    const key = offset;
    offset += part.length;
    return (
      <React.Fragment key={key}>
        {part}
        {delimiters.includes(part) && <wbr />}
      </React.Fragment>
    );
  });
};
